// Angular imports
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
// 3rd party imports
import { plainToClass } from 'class-transformer';
// Constant imports
import { URLConstants } from '../../_constants/url-constants';
// Model imports
import { SecurityInfoResultDto } from '../_models/security-info-result-dto';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class SecurityInfoService {
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    getApiUriSecurityInfo(uri, action) {
        const urlWithParams = `${URLConstants.ccUserBaseApiUrl}/uri/securityinfo?uri=${uri}&action=${action}`;
        return this.getSecurityInfo(urlWithParams);
    }
    getAccessCodeSecurityInfo(accessCode) {
        const urlWithParams = `${URLConstants.ccUserBaseApiUrl}/action/securityinfo?actionCode=${accessCode}`;
        return this.getSecurityInfo(urlWithParams);
    }
    getConfigSecurityInfo(name, category) {
        const urlWithParams = `${URLConstants.ccUserBaseApiUrl}/config/securityinfo?name=${name}&category=${category}`;
        return this.getSecurityInfo(urlWithParams);
    }
    getSecurityInfo(urlWithParams) {
        return this.httpClient
            .get(urlWithParams)
            .pipe(map((response) => plainToClass(SecurityInfoResultDto, response)));
    }
}
SecurityInfoService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SecurityInfoService_Factory() { return new SecurityInfoService(i0.ɵɵinject(i1.HttpClient)); }, token: SecurityInfoService, providedIn: "root" });
